import {
  WorkOrderComplementStatus,
  WorkOrderComplementType,
} from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import useValidateRoutes from '@/hooks/useValidateRoutes';
import { RouteType } from '@/types/RouteType';

const workOrderValidationTabs = (
  route: RouteType,
  type?: WorkOrderComplementType,
  complement?: WorkOrderComplementStatus,
) => {
  let routeValidate = useValidateRoutes({
    route: route.parent,
    validation: complement !== WorkOrderComplementStatus.Authorized,
    keys: [
      'complements/:complementId/financial',
      'complements/:complementId/invoice',
    ],
  });

  const routeValidateClosed = useValidateRoutes({
    route: route.parent,
    validation: complement !== WorkOrderComplementStatus.Closed,
    keys: ['complements/:complementId/financial'],
  });

  if (
    complement === WorkOrderComplementStatus.Closed &&
    !(
      type === WorkOrderComplementType.Courtesy ||
      type === WorkOrderComplementType.Warranty ||
      type === WorkOrderComplementType.Return
    )
  ) {
    if (type === WorkOrderComplementType.TotalLoss) {
      routeValidate = {
        ...routeValidate,
        routes: routeValidate.routes.filter(
          (route) =>
            ![
              'complements/:complementId/financial',
              'complements/:complementId/invoice',
            ].includes(route.key),
        ),
      };
    } else {
      return routeValidateClosed;
    }
  }

  if (
    type === WorkOrderComplementType.Courtesy ||
    type === WorkOrderComplementType.Warranty ||
    type === WorkOrderComplementType.Return
  ) {
    routeValidate = {
      ...routeValidate,
      routes: routeValidate.routes.filter(
        (route) => route.key !== 'complements/:complementId/financial',
      ),
    };

    if (complement === WorkOrderComplementStatus.Closed) {
      return useValidateRoutes({
        route: route.parent,
        validation: complement === WorkOrderComplementStatus.Closed,
        keys: ['complements/:complementId/financial'],
      });
    }
  }

  if (type === WorkOrderComplementType.TotalLoss) {
    routeValidate = {
      ...routeValidate,
      routes: routeValidate.routes.filter(
        (route) =>
          ![
            'complements/:complementId/financial',
            'complements/:complementId/invoice',
          ].includes(route.key),
      ),
    };
  }

  return routeValidate;
};

export default workOrderValidationTabs;
